import { ButtonHeading, CustomPagination } from 'components';
import BootstrapTable from 'components/BootstrapTable';
import { UserContext } from 'context';
import React, { useContext, useEffect, useRef, useState } from 'react'
import moment from 'moment';
import Loading from 'pages/Loading';
import LoadingBar from 'react-top-loading-bar';
import "./index.css"
import StorageService from 'utils/StorageServices';
import { getPodFollowupList } from '_services/accountsServices/podFollowupServices';
import MastersFilterModal from 'modals/MastersFilterModal';
import { utils } from 'helper';
import { AddEditLrModal, LrDetailModal, PodFollowupFilterModal } from 'modals';
import { API, AppConfig } from 'lib';

// const billRaiseInvoiceListTabs = [
//     { id: 0, name: "Above 30Days", css_Class: `__tabClss1`, balance: 7, amount_key: 'Pending', invoice_amount: 50000 },
//     { id: 1, name: "Under 16- 30 Days", css_Class: `__tabClss2`, value: "__pending_icon", balance: 7, amount_key: 'Total', invoice_amount: 50000 },
//     { id: 3, name: "Under 8-15 Days", css_Class: `__tabClss3`, value: "__completed_icon", balance: 7, amount_key: 'Today', invoice_amount: 50000 },
//     { id: 4, name: "Under 7 Days", css_Class: `__tabClss4`, value: "__cancelled_icon", balance: 7, amount_key: 'Today', invoice_amount: 50000 },
// ]

const billRaiseInvoiceListTabs = [
    // { id: 0, name: "All Days", css_Class: `__tabClss1`, balance: 0, amount_key: 'Pending', invoice_amount: 0 },
    { id: 'above30', name: "Above 30 Days", css_Class: `__tabClss2`, value: "__pending_icon", balance: 0, amount_key: 'Total', invoice_amount: 0 },
    { id: 'between8_15', name: "Between 8-15 Days", css_Class: `__tabClss3`, value: "__completed_icon", balance: 0, amount_key: 'Today', invoice_amount: 0 },
    { id: 'between16_30', name: "Between 16-30 Days", css_Class: `__tabClss4`, value: "__cancelled_icon", balance: 0, amount_key: 'Today', invoice_amount: 0 },
    { id: 'under7', name: "Under 7 Days", css_Class: `__tabClss1`, balance: 0, amount_key: 'Pending', invoice_amount: 0 },
]

const PodFollowup = () => {

    const [podFollowList, setPodFollowList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [podCounts, setPodCounts] = useState(billRaiseInvoiceListTabs);
    const [invoiceActiveTab, setInvoiceActiveTab] = useState('under7');
    const [showFilterModal, setShowFilterModal] = useState(false);
    const { masterData, lrModalToggleForEway } = useContext(UserContext)

    const [filterCount, setFilterCount] = useState(0);

    const loadingBarRef = useRef(null);

    const [excelLoading, setExcelLoading] = useState(false);
    let isToken = localStorage.getItem("token");

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
        lr_status: '',
        // pod_status: '',
    });

    const [showLrDetail, setShowLrDetail] = useState(false)
    const [showAddLR, setShowAddLR] = useState(false)

    const tabHandler = (id) => {
        setInvoiceActiveTab(id);
        setFilter((s) => ({ ...s, offset: 1 }))
    }

    const handleDetailsAction = (data) => {
        setShowLrDetail(data);
    }

    const columns = [
        { header: "LR Date", accessor: "lr_date" },
        { header: "LR Number", accessor: "lr_number" },
        { header: "MLR No", accessor: "mlr_no" },
        { header: "Party", accessor: "consignor_name" },
        { header: "From Location", accessor: "from_location" },
        { header: "To Location", accessor: "to_location" },
        { header: "Supplier/ Driver", accessor: "supplier" },
        { header: "Status", accessor: "pod_status" },
        { header: "Vehicle Number", accessor: "vehicle_number" },
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            lr_date: <>
                {item?.dispatch_date ? utils.getDate(item?.dispatch_date) : '-'}
            </>,
            lr_number: item?.lr_number ? <div className='_tblText _lrNums __inLineNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> {item?.lr_number} </a> </div> : <div className='_tblText _lrNums __inLineNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> View </a> </div>,
            mlr_no: <>{item?.mlr_number ? item?.mlr_number : item?.lr_number}</>,
            consignor_name: item?.consignor_id?.name ? <div className='_tblText _oneLine_tx'>{item?.consignor_id?.name}</div> : '-',
            from_location: item?.from_location ? (
                <div className='_locationWid_bx'
                // onClick={(e) => handleDetailsAction(item)}
                >
                    <p className="_tblText">{item.from_location}</p>
                    {((item.unit_id && item.unit_id.code) || (item.unit_id && item.unit_id.name)) && <p className="_lgtText">{item.unit_id && item.unit_id.code && item.unit_id.code} | {item.unit_id && item.unit_id.name && item.unit_id.name} </p>}
                </div>
            ) : '-',
            to_location: item?.to_location ? (
                <div className='_locationWid_bx'>
                    <p className="_tblText">{item.to_location}</p>
                    {((item.consignee_id && item.consignee_id.code) || (item.consignee_id && item.consignee_id.name)) && <p className="_lgtText">{item.consignee_id && item.consignee_id.code && item.consignee_id.code} | {item.consignee_id && item.consignee_id.name && item.consignee_id.name} </p>}
                </div>
            ) : '-',
            supplier:
                <div className='_locationWid_bx'>
                    <p className="_tblText">{item?.trip_id?.vehicle_ownership === 2 ? item?.trip_id?.supplier_id?.name : item?.trip_id?.driver_id?.name}</p>
                    <p className="_lgtText">{item?.trip_id?.vehicle_ownership === 2 ? 'Supplier' : 'Driver'} </p>
                </div>,
            vehicle_number: <div className='_tblText'>{item?.trip_id?.vehicle_id?.vehicle_no || ''}</div>,
            pod_status: item?.pod_status ? <span className={masterData?.pod_status[item?.pod_status] === 'Pending' ? '_lrPending_status' : (masterData?.pod_status[item?.pod_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.pod_status[item?.pod_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.pod_status[item?.pod_status] === 'Received' ? '_lrDelivered_status' : (masterData?.pod_status[item?.pod_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.pod_status[item?.pod_status] ? masterData?.pod_status[item?.pod_status] : ''} </span>
                : '-',
            // lr_status: item?.lr_status ? (
            //     <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span>
            // ) : '-',
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const getDataPodFollowUpList = async () => {
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                day_filter: invoiceActiveTab,
                driver_id: filter?.driver_id ? filter?.driver_id : '',
                supplier_id: filter?.supplier_id ? filter?.supplier_id : '',
                branch_id: filter?.branch_id ? filter?.branch_id : '',
                consignor_id: filter?.consignor_id ? filter?.consignor_id : '',
                vehicle_id: filter?.vehicle_id ? filter?.vehicle_id : '',
                search: filter?.search ? filter?.search : '',
                lr_status: filter?.lr_status ? filter?.lr_status : '',
                offset: filter?.offset,
                limit: filter?.limit,
                // pod_status: filter?.pod_status ? filter?.pod_status : ''
            }
            const res = await getPodFollowupList(object);
            if (res?.responseCode == 200) {
                setPodFollowList(res?.data);

                const array = [
                    // { id: 0, name: "All Days", css_Class: `__tabClss0`, balance: res?.data?.summary?.all_count, amount_key: 'Pending', invoice_amount: res?.data?.summary?.all_value },
                    { id: 'above30', name: "Above 30 Days", css_Class: `__tabClss1`, value: "__pending_icon", balance: res?.data?.summary?.above30, amount_key: 'Total', invoice_amount: res?.data?.summary?.above30_val },
                    { id: 'between8_15', name: "Between 8-15 Days", css_Class: `__tabClss2`, value: "__completed_icon", balance: res?.data?.summary?.between8_15, amount_key: 'Today', invoice_amount: res?.data?.summary?.between8_15_val },
                    { id: 'between16_30', name: "Between 16-30 Days", css_Class: `__tabClss3`, value: "__cancelled_icon", balance: res?.data?.summary?.between16_30, amount_key: 'Today', invoice_amount: res?.data?.summary?.between16_30_val },
                    { id: 'under7', name: "Under 7 Days", css_Class: `__tabClss4`, balance: res?.data?.summary?.under7, amount_key: 'Pending', invoice_amount: res?.data?.summary?.under7_val },
                ]
                setPodCounts(array);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
            // throw error;
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    useEffect(() => {
        getDataPodFollowUpList();
    }, [filter, invoiceActiveTab]);

    useEffect(() => {
        const filteredValues = Object.entries(filter)
            .filter(
                ([key, val]) =>
                    key !== "offset" &&
                    key !== "limit" &&
                    key !== "company_id" &&
                    key !== "status" &&
                    key !== "branch_name" &&
                    key !== "consignor_name" &&
                    key !== "driver_name" &&
                    key !== "supplier_name" &&
                    key !== "start_date" &&
                    key !== "end_date" &&
                    key !== "vehicle_no" &&
                    key !== "firm_id" &&
                    val !== "" &&
                    val !== null &&
                    val !== undefined &&
                    val !== 0
            )
            .map(([_, val]) => val);

        setFilterCount(filteredValues.length);

    }, [filter]);

    const clearFilter = () => {
        setFilter((s) => ({
            ...s,
            company_id: "",
            consignor_id: "",
            consignor_name: "",
            supplier_id: "",
            supplier_name: "",
            driver_id: "",
            driver_name: "",
            vehicle_ownership: 0,
            from_location: "",
            to_location: "",
            branch_id: "",
            branch_name: "",
            start_date: "",
            end_date: "",
            limit: 25,
            offset: 1,
            lr_status: "",
            // pod_status: "",
            search: "",
            trip_status: 0,
            vehicle_id: "",
            vehicle_no: null, // ✅ Reset to null
        }));

        setFilterCount(0);
    };

    const exportHandle = async () => {
        setExcelLoading(true);
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
                day_filter: invoiceActiveTab ? invoiceActiveTab : '',
                driver_id: filter?.driver_id ? filter?.driver_id : '',
                supplier_id: filter?.supplier_id ? filter?.supplier_id : '',
                branch_id: filter?.branch_id ? filter?.branch_id : '',
                consignor_id: filter?.consignor_id ? filter?.consignor_id : '',
                vehicle_id: filter?.vehicle_id ? filter?.vehicle_id : '',
                search: filter?.search ? filter?.search : '',
                lr_status: filter?.lr_status ? filter?.lr_status : '',
                // pod_status: filter?.pod_status ? filter?.pod_status : ''
            };
            const response = await fetch(
                `${AppConfig.api_baseurl}${API.EXPORT_POD_FOLLOWUP}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Token: `${isToken}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "transport360_POD.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            setExcelLoading(false);
        } catch (error) {
            setExcelLoading(false);
        }
    };

    const handleNextModal = (data) => {
        setShowLrDetail(!showLrDetail);
        setShowAddLR(data);
    }

    return (
        <>
            <div className='__podFollowMain_bxs'>
                <LoadingBar
                    color="#ffa800"
                    ref={loadingBarRef}
                    height={4}
                    shadow={true}
                    loaderSpeed={1000}
                />

                <ButtonHeading
                    title={"POD Followup"}
                    className="commonHeading_title"
                    showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
                    onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                    filter={filter}
                    setFilter={setFilter}
                    filterCount={filterCount}
                    clearFilter={clearFilter}
                    isDebouncedSearch={false}
                    Export={true}
                    exportLoading={excelLoading}
                    ExportDissable={excelLoading}
                    ExportSubmit={(e) => exportHandle(e)}
                />

                <div className='_podFollowup_tableBx'>
                    <div className='_pod_followup'>
                        <ul className="nav nav-tabs" id="myTabNx" role="tablist">
                            {
                                podCounts?.map((el, ind) => {
                                    return (
                                        <li className={`nav-item ${el?.css_Class}`} role="presentation" key={ind + el?.name}>
                                            <button
                                                style={{ border: el?.color }}
                                                className={`nav-link ${(invoiceActiveTab === el?.id) ? 'active' : ''}`}
                                                type="button"
                                                aria-selected={(invoiceActiveTab === el?.id)}
                                                onClick={(e) => tabHandler(el?.id)}
                                            // disabled={disabled}
                                            >
                                                <div className='__pod_flex'>
                                                    <p className='__textColor'> {el?.name} </p>
                                                    <p className='__gnTextColor'> {el?.balance || 0} | {el?.invoice_amount || 0}  </p>
                                                </div>
                                            </button>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>

                    {loading ?
                        <div className='_tabWith_invoiceTab' style={{ justifyContent: 'center' }}>
                            <div key="loader">
                                <div colSpan={columns?.length} style={{ textAlign: "center" }}>
                                    <Loading />
                                </div>
                            </div>
                        </div>
                        :
                        <>
                            <div className='_tabWith_invoiceTab'>
                                <BootstrapTable
                                    tableClass="__invoiceTble"
                                    columns={columns}
                                    data={rowListData(podFollowList?.list?.length > 0 ? podFollowList?.list : [])}
                                />
                            </div>
                        </>
                    }
                </div>
                {podFollowList?.list?.length > 0 &&
                    <div className='paginationFt_avt '>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>}
            </div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showFilterModal ? 'visible' : 'hidden' }}
            >
                {showFilterModal &&
                    <PodFollowupFilterModal
                        isOpen={showFilterModal}
                        onClose={() => setShowFilterModal(false)}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={{
                            allBranch: true,
                            consignor: true,
                            supplier: true,
                            driver: true,
                            vehicle: true,
                            lr_status: true,
                            // pod_status: true,
                        }}
                        setFilterCount={setFilterCount}
                        filterCount={filterCount}
                        name="PodFollowup"
                    />
                }
            </div>
            <div className={showFilterModal ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
            >
                {showLrDetail
                    && (
                        <LrDetailModal
                            isOpen={showLrDetail}
                            onClose={(e) => setShowLrDetail(false)}
                            nextModal={(e) => handleNextModal(e)}
                        // callGetData={() => { getLrDataList(); getLrTopStatusCount(); }}
                        />
                    )
                }
            </div>
            <div className={showLrDetail ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showAddLR ? 'visible' : 'hidden' }}
            >
                {showAddLR
                    && (
                        <AddEditLrModal
                            isOpen={showAddLR}
                            onClose={() => setShowAddLR(false)}
                            callGetData={() => getDataPodFollowUpList()}
                        />
                    )
                }
            </div>
            <div className={showAddLR ? 'offBack_drop' : ''} style={{ zIndex: lrModalToggleForEway?.ewayModal ? 9999 : 999 }}></div>
        </>
    )
}

export default PodFollowup